module.exports = __webpack_public_path__ + "static/media/18.0074f40e.png";